export default class AtividadeChecklist {

  constructor(
    IdEmpresa = 1,
    IdAtividade = null,
    IdChecklist = null,
    Descricao = '',
    Concluido = false,
    IdOrdem = null
  ) {

    this.IdEmpresa = IdEmpresa;
    this.IdAtividade = IdAtividade;
    this.IdChecklist = IdChecklist;
    this.Descricao = Descricao;
    this.Concluido = Concluido;
    this.IdOrdem = IdOrdem;
  }
  
}